angular.module('controllers').controller('sectionController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$http', '$route', '$routeParams', '$location', '$timeout', '$interval', '$compile', '$q',
	function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $http, $route, $routeParams, $location, $timeout, $interval, $compile, $q) {
		$rootScope.path = '/section';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'section';
		$scope.pathTemplate = 'distribution/sections';
		$scope.title = 'Cartiere';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'street_no';
		$scope.defaultItem = 10;
		$rootScope.typeId = 'id';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'county_name':{'label':'Judet', 'filter':1, 'filterType':'input'},
			'locality_name':{'label':'Localitate', 'filter':1, 'filterType':'input'},
			'section_name':{'label':'Cartier', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.search.order = 'asc';
		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'section_name';
		$scope.additionals['jsonPath'] = '/json';

		$scope.additionals['searchTerm'];
		$scope.additionals['clearSearchTerm'] = function() {
			$scope.additionals['searchTerm'] = '';
		};
		$scope.additionals['onSearchChange'] = function(ev) {
			ev.stopPropagation();
		};

		$scope.additionals['getCounties'] = function () {
			Crud.get($scope.additionals['jsonPath'] + '/counties.json')
				.success(function (data) {
					$scope.additionals['counties'] = data;
				});
		}
		$scope.additionals['getCounties']();

		/* autocomplete */
		function createFilterFor(query) {
			var capitalizeQuery = $scope.formatText(query);
			return function filterFn(item) {
				return item.locality_name.indexOf(capitalizeQuery) >= 0;
			};
		}
		$scope.additionals['getLocalities'] = function(model, index) {
			model.locality_id = 0;
			Crud.get($scope.path + '/getLocalities?county_name='+model.county_name)
				.success(function (dataLoc) {

					if(dataLoc.localities.length <= 0) {

						Crud.get($scope.additionals['jsonPath'] + '/localities.json')
							.success(function (data) {
								if (angular.isUndefined(model.county_name)) {
									$scope.additionals['getLocalities']({"county_name": "Cluj"});
								} else {
									if (!angular.isUndefined(index)) {
										$scope.additionals['localities' + index] = data[model.county_name];
									} else {
										$scope.additionals['localities'] = data[model.county_name];
									}
								}
								/* autocomplete */
								function querySearch(query) {
									if (!angular.isUndefined(index)) {
										var results = query ? $scope.additionals['localities' + index].filter(createFilterFor(query)) : [];
									} else {
										if (!angular.isUndefined($scope.additionals['localities'])) {
											var results = query ? $scope.additionals['localities'].filter(createFilterFor(query)) : [];
										}
									}
									return results;
								}
								$scope.additionals['searchLocality'] = querySearch;
								$scope.additionals['errors'] = {};
								/* end autocomplete */

							});
					} else {
						if (angular.isUndefined(model.county_name)) {
							$scope.additionals['getLocalities']({"county_name": "Cluj"});
						} else {
							if (!angular.isUndefined(index)) {
								$scope.additionals['localities' + index] = dataLoc['localities'];
							} else {
								$scope.additionals['localities'] = dataLoc['localities'];
							}
						}
						/* autocomplete */
						function querySearch(query) {
							if (!angular.isUndefined(index)) {
								var results = query ? $scope.additionals['localities' + index].filter(createFilterFor(query)) : [];
							} else {
								if (!angular.isUndefined($scope.additionals['localities'])) {
									var results = query ? $scope.additionals['localities'].filter(createFilterFor(query)) : [];
								}
							}
							return results;
						}
						$scope.additionals['searchLocality'] = querySearch;
						$scope.additionals['errors'] = {};
						/* end autocomplete */
					}

				});
		}
		/* end autocomplete */

		if (angular.isUndefined($scope.search.county)) {
			$scope.search.county_name = 'Cluj';
		}

		$scope.additionals['function']= function(ev, model) {
			$scope.additionals['selectedItemLocality'] = '';

			if (angular.isUndefined(model.county_name)) {
				$scope.additionals['getLocalities']({"county_name":"Cluj"});
			}
			if($scope.action == 'store') {
				if (angular.isUndefined(model.county_name)) {
					model.county_name = 'Cluj';
				}
			}
			if($scope.action == 'update') {
				$scope.additionals['getLocalities'](model);
			}
			if($scope.action == 'updatemultiple') {
				$scope.additionals['selectedItemLocality'] = [];
				angular.forEach(model, function (item, index) {
					$scope.additionals['getLocalities'](item, index);
				});
			}

		}

		$scope.additionals['internFunction'] = function(ev, model) {
			if($scope.action == 'updatemultiple') {
				angular.forEach(model, function (item, index) {
					if(index != 'route') {
						if (!angular.isUndefined($scope.additionals['localities'+index])) {
							if (!angular.isUndefined($scope.additionals['localities' + index][0]['id'])) {
								var checkLocalityId = $scope.additionals['checkField']($scope.additionals['localities' + index], 'id', 'locality_name', item['locality_name']);
								if (checkLocalityId) {
									item.locality_id = checkLocalityId;
								} else {
									item.locality_id = 0;
								}
							} else {
								item.locality_id = 'js';
							}
						}

						var checkLocalityName = $scope.additionals['checkField']($scope.additionals['localities'+index], 'locality_name', 'locality_name', item['locality_name']);
						if (checkLocalityName) {
							item.locality_name = checkLocalityName;
						} else {
                            if(item.locality_id == 'js') {
                                item.locality_name = '';
                            }
                        }
					}
				});
			} else {
				if (model['locality_name'] != '' && $scope.additionals['localities']) {
					if (!angular.isUndefined($scope.additionals['localities'][0]['id'])) {
						var checkLocalityId = $scope.additionals['checkField']($scope.additionals['localities'], 'id', 'locality_name', model['locality_name']);
						if (checkLocalityId) {
							model.locality_id = checkLocalityId;
						} else {
							model.locality_id = 0;
						}
					} else {
                        model.locality_id = 'js';
					}

					var checkLocalityName = $scope.additionals['checkField']($scope.additionals['localities'], 'locality_name', 'locality_name', model['locality_name']);
					if (checkLocalityName) {
						model.locality_name = checkLocalityName;
					} else {
                        if(model.locality_id == 'js') {
                            model.locality_name = '';
                        }
					}

				}
			}
		}

        /* change field */
        $scope.additionals['changeField']= function(model, key) {
            if (!angular.isUndefined(key)) {
                model[key].locality_new = false;
            } else {
                model.locality_new = false;
            }
        }

		$scope.additionals['functionResult']= function(ev, data) {
			if($scope.action == 'update' || $scope.action == 'store') {
				if (!angular.isUndefined($scope.modelData.section_name)) {
					$scope.modelData.section_name = $scope.additionals['formatTextResult']($scope.modelData.section_name);
				}
			}
			if($scope.action == 'updatemultiple') {
				if (!angular.isUndefined($scope.modelsData)) {
					angular.forEach($scope.modelsData, function (item, key) {
						if (item.selected !== false) {
							if (!angular.isUndefined($scope.modelsData[key].section_name)) {
								$scope.modelsData[key].section_name = $scope.additionals['formatTextResult']($scope.modelsData[key].section_name);
							}

						}
					});
				}

			}
		}

		/* close field */
		$scope.additionals['closeField'] = function (paramName, model, key) {
			if (!angular.isUndefined(key)) {
				model[key][paramName] = '';
			} else {
				model[paramName] = '';
			}
		}

        /* draw sections */
        $scope.center = [46.779608, 23.593165];
        $scope.initMap = function () {
            var OpenStreetMap = L.tileLayer(
                'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                {maxZoom: 22, type: 'osm'}
            );
            var LocalOpenStreet = L.tileLayer(
                'https://api.947.ro:8081/tiles/{z}/{x}/{y}.png',
                {maxZoom: 22, type: 'osm_local'}
            );

            if (!$scope.map || $scope.map == undefined) {
                $scope.map = L.map('map-draw-sections', {
                    center: $scope.center,
                    zoom: 13,
                    scrollWheelZoom: true,
                    zoomControl: true,
                    attributionControl: true,
                    layers: [LocalOpenStreet],
                });
                //$scope.map.dragging.disable();
                $scope.map._onResize();
                $scope.map.invalidateSize();

                var fullScreenControl =  L.Control.extend({
                    options: {
                        position: 'topleft'
                    },
                    onAdd: function (map) {
                        var container = L.DomUtil.create('button', 'leaflet-bar leaflet-control leaflet-control-custom leaflet-control-fullscreen minus');
                        container.title = "Fullscreen";
                        container.onclick = function(ev) {
                            $scope.fullscreenMap(ev);
                        }
                        return container;
                    }
                });
                $scope.map.addControl(new fullScreenControl());

                /*var saveCoordinatesControl =  L.Control.extend({
                    options: {
                        position: 'topleft'
                    },
                    onAdd: function (map) {
                        var container = L.DomUtil.create('button', 'leaflet-bar leaflet-control leaflet-control-custom leaflet-control-brightnessmap');
                        container.title = "Salveaza coordonate";
                        container.onclick = function(ev) {
                            $scope.saveCollection(ev);
                        }
                        return container;
                    }
                });
                $scope.map.addControl(new saveCoordinatesControl());*/

                $scope.map.pm.addControls({
                    position: 'topleft',
                    drawCircle: false,
                    drawMarker: false,
                    drawPolyline: false,
                    drawRectangle: false,
                    cutPolygon: false,
                    drawCircleMarker: false,
                    oneBlock: true,
                    editMode: false
                });
                //$scope.map.pm.enableGlobalEditMode({});
            }
        }

        $scope.fullscreenMap = function (ev) {
            $scope.goPreview('map-draw-sections');
            angular.element(document.querySelector('.leaflet-control-fullscreen')).toggleClass('minus plus');
            angular.element(document.querySelector('.angular-leaflet-map')).css('height', '100%');
        }

        $scope.addSectionsToMap = function (data) {
            if ($scope.map && $scope.map != undefined) {
                var jsonData = [];
                angular.forEach(data, function (itemSection, keySection) {
                    var jsonCoordinates = [];
                    angular.forEach(itemSection['coordinates'], function (itemCoordinate, keyCoordinate) {
                        jsonCoordinates[keyCoordinate] = [itemCoordinate[1], itemCoordinate[0]];
                        jsonData[keySection] = {"label" : itemSection['label'], "type" : "Feature", "geometry" : {"type" : "Polygon","coordinates" : [jsonCoordinates] }};
                    });
                });
                var geoJsonData = {
                    type: 'FeatureCollection',
                    features: jsonData
                };
                var i= 0;
                var theCollection = L.geoJson(geoJsonData, {
                    onEachFeature: function(feature, layer) {
                        //console.log(feature)
                        //console.log(layer)

                        if(angular.isUndefined($scope.label)){
                            $scope.label = [];
                        }
                        if(angular.isUndefined($scope.label_old)){
                            $scope.label_old = [];
                        }
                        $scope.label_old[i] = feature.label;
                        $scope.label[i] = feature.label;

                        var content = '<div><div ng-include src="\'views/' + $scope.pathTemplate + '/partials/_formLabelSection.html\'"></div></div>';
                        var _templateScope;
                        if (!_templateScope) {
                            _templateScope = $scope.$new();
                        }
                        if ($scope.label[i]) {
                            _templateScope.label[i] = $scope.label[i];
                        }
                        if ($scope.label_old[i]) {
                            _templateScope.label_old[i] = $scope.label_old[i];
                        }
                        _templateScope.labelId = i;
                        _templateScope.layer = layer;
                        var compiled = $compile(content)(_templateScope);

                        if(angular.isUndefined($scope.labels)){
                            $scope.labels = [];
                        }
                        $scope.labels[i] = L.marker(layer.getBounds().getCenter(), {
                            icon: L.divIcon({
                            className: 'label',
                            html: '<div class="section-label">'+$scope.label[i]+'</div>',
                            /*iconSize: [100, 40]*/
                          }),
                            feature: $scope.label[i]
                        }).addTo($scope.map)
                            //.bindPopup('<h1>'+feature.label+'</h1>');
                            .bindPopup(compiled[0]);

                        layer.on('click', function () {
                            //console.log('click event')
                            layer.pm.enable({
                                allowSelfIntersection: true,
                                allowEditing: true
                            });
                            layer.on('pm:edit', function(e) {
                                //console.log('edit on layer')
                                var coordinates = [];
                                angular.forEach(e.layer.getLatLngs()[0], function (item, key) {
                                    coordinates[key] = [item['lat'], item['lng']];
                                });
                                collection =
                                    {"label" : e["layer"]["feature"]["label"],
                                        "coordinates" : coordinates
                                    };
                                $scope.saveCollection(collection);
                            });
                        });

                        i = i+1;
                    }
                });
                theCollection.addTo($scope.map);

                /*theCollection.on('pm:edit', function(e) {
                    console.log('edit')
                    var coordinates = [];
                    angular.forEach(e.layer.getLatLngs()[0], function (item, key) {
                        coordinates[key] = [item['lat'], item['lng']];
                    });
                    collection =
                        {"label" : e["layer"]["feature"]["label"],
                         "coordinates" : coordinates
                        };
                    $scope.saveCollection(collection);
                });*/

                $scope.map.on('pm:create', function(e) {
                    //console.log('create');

                    var coordinates = [];
                    if(!angular.isUndefined($scope.labels)) {
                        i = $scope.labels.length;
                    } else {
                        i = 0;
                    }
                    angular.forEach(e.layer.getLatLngs()[0], function (item, key) {
                        coordinates[key] = [item['lat'], item['lng']];
                    });
                    if(angular.isUndefined(e.layer.custom_feature)){
                        e.layer.custom_feature = {};
                    }
                    e.layer.custom_feature.label = 'layer'+i;
                    collection =
                        {"label" : 'layer'+i,
                         "coordinates" : coordinates
                        };
                    $scope.saveCollection(collection);

                    if(angular.isUndefined($scope.label)){
                        $scope.label = [];
                    }
                    if(angular.isUndefined($scope.label_old)){
                        $scope.label_old = [];
                    }
                    $scope.label_old[i] = collection.label;
                    $scope.label[i] = collection.label;

                    var content = '<div><div ng-include src="\'views/' + $scope.pathTemplate + '/partials/_formLabelSection.html\'"></div></div>';
                    var _templateScope;
                    if (!_templateScope) {
                        _templateScope = $scope.$new();
                    }
                    if ($scope.label[i]) {
                        _templateScope.label[i] = $scope.label[i];
                    }
                    if ($scope.label_old[i]) {
                        _templateScope.label_old[i] = $scope.label_old[i];
                    }
                    _templateScope.labelId = i;
                    _templateScope.layer = e.layer;
                    var compiled = $compile(content)(_templateScope);

                    if(angular.isUndefined($scope.labels)){
                        $scope.labels = [];
                    }
                    $scope.labels[i] = L.marker(e.layer.getBounds().getCenter(), {
                        icon: L.divIcon({
                            className: 'label',
                            html: '<div class="section-label">'+$scope.label[i]+'</div>',
                            /*iconSize: [100, 40]*/
                        }),feature: $scope.label[i]
                    }).addTo($scope.map)
                        //.bindPopup('<h1>'+feature.label+'</h1>');
                        .bindPopup(compiled[0]);

                    $scope.labels = $scope.labels.filter(function (el) {
                        return el != 'empty';
                    });
                    e.layer.on('click', function () {
                        //console.log('click event')
                        e.layer.pm.enable({
                            allowSelfIntersection: true,
                            allowEditing: true
                        });
                        e.layer.on('pm:edit', function(f) {
                            //console.log('edit new layer');
                            var coordinatesNew = [];
                            angular.forEach(f.layer.getLatLngs()[0], function (itemNew, keyNew) {
                                coordinatesNew[keyNew] = [itemNew['lat'], itemNew['lng']];
                            });
                            if (!angular.isUndefined(f["layer"]["custom_feature"])) {
                                var label_edit = f["layer"]["custom_feature"]["label"];
                            }
                            if (!angular.isUndefined(f["layer"]["feature"])) {
                                var label_edit = f["layer"]["feature"]["label"];
                            }
                            collectionNew =
                                {"label" : label_edit,
                                    "coordinates" : coordinatesNew
                                };
                            $scope.saveCollection(collectionNew);
                        });

                    });
                });

                $scope.map.on('pm:remove', function(e) {
                    //console.log('remove');
                    if (!angular.isUndefined(e["layer"]["custom_feature"]) || !angular.isUndefined(e["layer"]["feature"])) {
                        if (!angular.isUndefined(e["layer"]["custom_feature"])) {
                            var label_remove = e["layer"]["custom_feature"]["label"];
                        }
                        if (!angular.isUndefined(e["layer"]["feature"])) {
                            var label_remove = e["layer"]["feature"]["label"];
                        }
                        var collection =
                            {
                                "label_remove": label_remove
                            };
                        $scope.saveCollection(collection);
                        $timeout(function () {
                            var positionLabel = $scope.labels.map(function (f) {
                                return f.options.feature;
                            }).indexOf(label_remove);
                            if (!angular.isUndefined($scope.labels[positionLabel])) {
                                $scope.map.removeLayer($scope.labels[positionLabel]);
                                $scope.labels.splice(positionLabel, 1);
                            }
                        }, 500);
                    }

                });
            }
        }

        $scope.saveCollection = function (collection, label_old, label, labelId, layer) {
            $scope.map.closePopup();
            var post = {};
            post['route'] = 'createCoordinates';
            post['collection'] = JSON.stringify(collection);
            if (label && label != undefined && !angular.isUndefined(label) && label_old && label_old != undefined && !angular.isUndefined(label_old) && label != label_old) {
                post['label_old'] = label_old;
                post['label'] = label;
            }
            Crud.post('form-urlencoded', post, $scope.path+'/createCoordinates')
                .success(function (data) {

                    if(data) {
                        if (label && label != undefined && !angular.isUndefined(label) && label_old && label_old != undefined && !angular.isUndefined(label_old) && label != label_old) {

                            if(angular.isUndefined($scope.label)){
                                $scope.label = [];
                            }
                            if(angular.isUndefined($scope.label_old)){
                                $scope.label_old = [];
                            }
                           $scope.label_old[labelId] = label;
                            var customLabel = L.divIcon({
                                className: 'label',
                                html: '<div class="section-label">'+label+'</div>',
                            });
                            $scope.labels[labelId].setIcon(customLabel);
                            $scope.labels[labelId].feature = label;

                            if(!angular.isUndefined(layer)){
                                if(!angular.isUndefined(layer.custom_feature)){
                                    layer.custom_feature.label = label;
                                }
                                if(!angular.isUndefined(layer.feature)){
                                    layer.feature.label = label;
                                }
                            }

                        }
                    }
                });
        }

        $scope.drawSections = function (ev, path) {

            if($rootScope.mode_action == 'dialog') {
                $rootScope.mode_action = 'page';
            }
            if($rootScope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'drawsections';
                $scope.actionLabel = 'Desenare cartiere';
                $scope.errors = {};
                $scope.additionals['invalid'] = '';
                angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, 'slow');

                $scope.cancel = function () {
                    $scope.errors = {};
                    $scope.controlSH = false;
                };

                if ($scope.map && $scope.map != undefined && !angular.isUndefined($scope.map)) {
                    $scope.map._onResize();
                    $scope.map.invalidateSize();
                    $scope.map = null;
                }

                $timeout(function() {
                    $scope.initMap();
                    Crud.get($scope.additionals['jsonPath'] + '/sections.json?'+ new Date().getTime())
                        .success(function (data) {
                            $scope.addSectionsToMap(data);
                        });
                }, 500);
            }
        };

	}]
);
